import { Globals } from '../shared/globals';
import { Injectable } from '@angular/core';
import { JsonSerializer } from 'typescript-json-serializer';
import { AlertRule } from '../models/alert-rule.model';
import { Api } from '../shared/api';

@Injectable()
export class AlertRulesService {
  private jsonSerializer = new JsonSerializer();
  private alertRulesUrl = this.globals.apiUrl('alert-rules');

  constructor(private api: Api, private globals: Globals) {}

  public async createAlertRule(rule: AlertRule): Promise<void> {
    return await this.api.httpPost(
      this.alertRulesUrl,
      this.jsonSerializer.serializeObject(rule)
    );
  }

  public async getAlertRules(): Promise<AlertRule[]> {
    const result: string = await this.api.httpGet(this.alertRulesUrl);
    return this.jsonSerializer.deserializeObjectArray(result, AlertRule);
  }

  public async deleteAlertRule(rule: AlertRule): Promise<void> {
    return await this.api.httpDelete(`${this.alertRulesUrl}/${rule.id}`);
  }
}
